<script lang="ts" setup>
import { HeadingType } from '~/components/atoms/Heading.vue'

defineProps<{
  title: string
  type?: string
  date?: string
  description: string
  link: {
    url: string
    target: string
    text: string
  }
  titleTag?: HeadingType
}>()
</script>
<template>
  <Card class="card-text" :link="link">
    <Heading :is="titleTag || 'h3'" :data="title" look="h3" />
    <span v-if="type" class="type f-18 f-medium">{{ type }}</span>
    <span v-if="date" class="date f-18">{{ date }}</span>
    <template #sliding>
      <div class="description text-small" v-html="description" />
    </template>
  </Card>
</template>
<style lang="scss" scoped>
.card {
  --slide: 0 !important;
  display: flex;
  flex-direction: column;

  min-height: 572px;
  height: 100%;

  padding: 120px 36px 42px;
  min-height: 544px;

  background-color: var(--c-background-medium);
  @include transitions(background-color);
  @include breakpoint(ds) {
    padding: 160px 48px 56px;
    min-height: 572px;
  }
  @include hover {
    background-color: var(--c-background-light);
  }

  :deep(.sliding-content) {
    margin-top: auto;
  }
}
</style>
